// John Eldhose 20190205
import { RestfulGet } from './Restful';

export async function report() {
  const rpt = await RestfulGet('report', (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return rpt;
}



// WEBPACK FOOTER //
// ./src/Api/report.js